import type { MedicalCheckAssignment } from "@/lib/api";

export function getMedicalCheckDetailDescriptionKey(
  assignment: Pick<MedicalCheckAssignment, "status" | "archived">,
): string {
  if (assignment.archived) return "medicalCheckups.detailDialog.archivedRecord";

  switch (assignment.status) {
    case "pending":
      return "medicalCheckups.detailDialog.pendingAppointment";
    case "accepted":
      return "medicalCheckups.detailDialog.confirmedAppointment";
    case "attended":
      return "medicalCheckups.detailDialog.attendedAppointment";
    case "absent":
      return "medicalCheckups.detailDialog.absentAppointment";
    case "passed":
      return "medicalCheckups.detailDialog.passedRecord";
    case "failed":
      return "medicalCheckups.detailDialog.failedRecord";
    case "completed":
      return "medicalCheckups.detailDialog.completedRecord";
    case "rejected":
      return "medicalCheckups.detailDialog.declinedRecord";
    case "cancelled":
      return "medicalCheckups.detailDialog.cancelledRecord";
  }

  return "medicalCheckups.detailDialog.completedRecord";
}
